import React, {Component} from 'react'
import {Button} from 'reactstrap'
import PropTypes from 'prop-types'
import {graphql, withApollo} from 'react-apollo'
import {CreateExportWps} from '../mutations'
import {GET_JOBS} from '../../JobsNotifications/graphql'

class ExportWpsBtn extends Component {
  constructor() {
    super()
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  static propTypes = {
    mutate: PropTypes.func.isRequired,
    wps_id: PropTypes.number.isRequired,
    client: PropTypes.object.isRequired
  }

  handleSubmit(e) {
    e.stopPropagation()
    this.props.mutate({
      variables: {
        type: 'WlWelds::Jobs::ExportWps',
        args: JSON.stringify({
          format: 'pdf',
          version: 'wps',
          wps_id: this.props.wps_id
        })
      }
    }).then(() => {
      this.props.client.query({
        query: GET_JOBS,
        fetchPolicy: 'network-only'
      }).then(({ data }) => {
        const notifyCount = data.user_jobs ? data.user_jobs.filter(job => job.notify).length : 0
        const event = new CustomEvent('changeNotifyCountInApp', { detail: { notifyCount } })
        window.dispatchEvent(event)
      })
    })
  }

  render() {
    return (
      <Button id="export-welder-certificate-btn" color="primary" title="Export" onClick={this.handleSubmit}>
        <i className="fa fa-print"/>
      </Button>
    )
  }
}

const ExportWpsWithMutation = graphql(CreateExportWps)(ExportWpsBtn)

export default withApollo(ExportWpsWithMutation)



// WEBPACK FOOTER //
// ./src/components/Wps/export_wps/ExportWpsBtn.js